(function () {
    'use strict';

    angular
        .module('news')
        .controller('NewsListController', NewsListController);

    NewsListController.$inject = ['$uibModal', 'NewsService','$sce','toastr'];

    function NewsListController($uibModal,NewsService,$sce,toastr) {
        var vm = this;

        vm.flag                  = false;
        vm.newsResult            = [];
        vm.i                     = -1;
        vm.list                  = list;

        /*PAGINATION*/
        vm.pageChanged           = pageChanged;
        vm.setPage               = setPage;
        vm.to                    = [];
        vm.totalItems            = [];
        vm.currentPage           = null;
        vm.itemsPerPage          = [];
        vm.page                  = 1;
        vm.deleteNews            = deleteNews;

        function list() {
            vm.flag = false;
            vm.query = {};
            if(vm.page !== null)
                vm.query['page'] = vm.page;

            /* Load variables to CSV */
            NewsService.list(vm.query).then(function(response){
                vm.news = response.data.data;
                vm.flag = true;
                if(vm.news.length == 0){
                    vm.noResultMessage = 'Sorry, no results were found!';
                    vm.flag = false;
                } else {
                    vm.noResultMessage = '';
                    vm.flag = true;
                }
                vm.totalItems = response.data.total;
                vm.to         = response.data.to;
                vm.setPage(response.data.current_page);
                vm.itemsPerPage = response.data.per_page;

            }).catch(function(err){
            });
        }

        list();

        function setPage (pageNo) {
            vm.currentPage = pageNo;
        }

        function pageChanged (pageNo) {
            vm.page = vm.currentPage;
            vm.list();
        }

        vm.trustAsHtml = function trustAsHtml(string)
        {
            return $sce.trustAsHtml(string);
        };

        function deleteNews(id) {
            alertify
                .confirm('This action is irreversible!')
                .set('labels', {
                    ok: 'Ok',
                    cancel: 'Cancelar'
                })
                .set('title', 'Do you really want to delete this news?')
                .set('onok', function () {
                    /* Load variables to CSV */
                    NewsService.deleteNews(id).then(function(response){
                        if(response.status) {
                            vm.imgPath = response.url;
                            toastr.success(response.message);
                            list();
                        } else {
                            toastr.error(response.message);
                        }
                    }).catch(function(err){
                    });
                })
                .show();
        }
    }
})();